import TempClientDetail from "../../../components/cm/Dashboard/FullPages/ClientDetail/TempClientDetail";
import SideBarMain from "../../../components/cm/SideBarMain";
import AppWrapper from "../../../components/cm/AppWrapper";
import {Outlet, useParams} from "react-router-dom";

export default () => {
  const { id } = useParams()

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain/>}>
      <TempClientDetail id={id}>
        <Outlet/>
      </TempClientDetail>
    </AppWrapper.WithSidebar>
  );
};
